import { rgba } from 'polished';
import { colors, fonts, spacing } from '../tokens';
import button from './components/button';
import input from './components/input';
import alert from './components/alert';
import modal from './components/modal';
import tabs from './components/tabs';
import contentBox from './components/contentBox';
import csatWidget from './components/csatWidget';
import select from './components/select';
import textArea from './components/textArea';
import checkbox from './components/checkbox';
import tag from './components/tag';
import tooltip from './components/tooltip';
import slider from './components/slider';
import upload from './components/upload';

// TODO: pensar em como criar um tema padrao
export default {
  // colors,

  // palette,
  fonts: fonts,
  alert: alert,
  button: button,
  contentBox: contentBox,
  textArea: textArea,
  checkbox: checkbox,
  modal: modal,
  tooltip: tooltip,
  slider: slider,
  select: select,
  tabs: tabs,
  input: input,
  upload: upload,
  csatWidget: csatWidget,
  tag: tag,
  colors: {
    primary: colors.brand.primary,
    error: colors.error
  },
  textColors: {
    primary: colors.dark
  },
  circularProgress: {
    color: colors.brand.primary
  },
  calendar: {
    maxWidth: '384px',
    textColor: colors.dark,
    closeButtonColor: colors.grey[400],
    selectedTextColor: colors.brand.primary,
    disabledTextColor: 'rgba(0, 0, 0, 0.38)',
    daySelectedColor: colors.white,
    toolbarTextColor: colors.grey[200],
    toolbarSelectedTextColor: colors.white,
    toolbarSelectedFontSize: '32px',
    toolbarSelectedFontFamily: 'Metropolis-SemiBold',
    viewContainer: {
      boxShadow: '0 6px 6px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: colors.white
    },
    dateViewHeader: {
      colorDayLabel: colors.grey[500],
      arrowColor: '#859099',
      borderBottomLeftRadius: '4.8px',
      borderBottomRightRadius: '4.8px'
    },
    toolbar: {
      backgroundColor: colors.brand.primary,
      height: '88px',
      borderTopLeftRadius: '4.8px',
      borderTopRightRadius: '4.8px',
      padding: '16px 24px'
    },
    toolbarButton: {
      transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, font-size 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      fontSize: '14px',
      fontFamily: 'Metropolis-Regular',
      cursor: 'pointer'
    }
  },
  radio: {
    button: {
      checked: {
        color: colors.brand.primary
      },
      unchecked: {
        color: colors.grey[300]
      }
    },
    label: {
      color: colors.dark
    }
  },
  "switch": {
    controller: {
      color: colors.brand.primary,
      colorDisabled: colors.grey[100],
      boxShadow: "0 6px 12px 0 ".concat(rgba(colors.brand.primary, 0.6))
    },
    text: {
      color: colors.dark
    }
  },
  NPSWidget: {
    stickyContainer: {
      borderTop: "1px solid ".concat(colors.grey[100]),
      background: colors.white
    },
    container: {
      padding: spacing.l
    },
    closeButton: {
      iconSize: '12px',
      iconColor: colors.grey[400]
    },
    title: {
      fontFamily: '"Metropolis-Bold", sans-serif',
      fonts: fonts.base,
      color: colors.grey[600],
      responsive: {
        padding: "0 ".concat(spacing.xl)
      }
    },
    ratingContainer: {
      margin: spacing.m
    },
    ratingLabel: {
      fontFamily: '"Metropolis-Regular", sans-serif',
      fonts: fonts.s,
      color: colors.grey[400],
      marginX: spacing.m,
      marginY: spacing.s,
      responsive: {
        marginTop: spacing.xl,
        marginBottom: spacing.s,
        paddingX: spacing.xxl
      }
    },
    ratingButton: {
      fontFamily: '"Metropolis-Bold", sans-serif',
      size: spacing.xxl,
      fonts: fonts.s,
      backgroundSelected: colors.brand.primary,
      color: colors.grey[500],
      hoverColor: colors.brand.primary,
      colorSelected: colors.white,
      padding: spacing.s,
      margin: spacing.s,
      borderRadius: spacing.xs,
      border: "1px solid ".concat(colors.grey[400]),
      borderSelected: "1px solid ".concat(colors.brand.primary),
      hoverBorder: "1px solid ".concat(colors.brand.primary),
      responsive: {
        size: spacing.xxl2,
        margin: spacing.xs
      }
    },
    reasonContainer: {
      marginTop: spacing.m
    },
    reasonTextArea: {
      wrapper: {
        paddingTop: '11px',
        fonts: fonts.s
      },
      responsive: {
        fontFamily: '"Metropolis-Regular", sans-serif',
        fonts: fonts.xs
      }
    },
    submitButton: {
      marginTop: spacing.m,
      marginBottom: spacing.l,
      responsive: {
        marginBottom: spacing.xl
      }
    },
    feedbackContainer: {
      padding: spacing.xl
    },
    feedbackTitle: {
      fontFamily: '"Metropolis-Bold", sans-serif',
      fonts: fonts.xl,
      color: colors.grey[600],
      marginBottom: spacing.s
    },
    feedbackText: {
      fontFamily: '"Metropolis-Regular", sans-serif',
      fonts: fonts.base,
      color: colors.grey[600]
    }
  }
};